import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
} from 'vue-router'
import { translate } from '@/plugins/i18n'
const { VITE_APP_NAME } = import.meta.env

// 路由元信息类型扩展
declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean
    hideHeader?: boolean
    hideFooter?: boolean
    title?: string
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () =>
      VITE_APP_NAME == 'removebg.pro'
        ? import('@/views/Removebg/index.vue')
        : import('@/views/Home/index.vue'),
    meta: {
      title: 'header.home',
    },
  },
  {
    path: '/removebg',
    name: 'removebg',
    component: () => import('@/views/Removebg/index.vue'),
    meta: {
      title: 'header.removebg',
    },
  },
  {
    path: '/ai-create',
    name: 'aiCreate',
    component: () => import('@/views/AiCreate/index.vue'),
    meta: {
      hideFooter: true,
      title: 'header.aicreate',
    },
  },
   {
    path: '/ai-create/chat',
    name: 'aiCreateChat',
    component: () => import('@/views/AiCreate/chat.vue'),
    meta: {
      hideHeader: false,
      hideFooter: true,
      title: 'header.aicreate',
    },
  },
  {
    // 避免与服务器默认静态资源目录冲突，请勿使用 assets 作为路由名称
    path: '/app-assets',
    name: 'appAssets',
    component: () => import('@/views/AppAssets/index.vue'),
    meta: {
      hideFooter: true,
      title: 'header.assets',
    },
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/Pricing/index.vue'),
    meta: {
      title: 'header.pricing',
    },
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import('@/views/Legal/index.vue'),
    meta: {
      title: 'header.legal',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      hideHeader: true,
      hideFooter: true,
      title: 'header.login',
    },
  },
  {
    path: '/login/callback',
    name: 'logincallback',
    component: () => import('@/views/Login/callback.vue'),
    meta: {
      hideHeader: true,
      hideFooter: true,
      title: 'header.login',
    },
  },
  {
    path: '/extension',
    name: 'extension',
    component: () => import('@/views/Extension/index.vue'),
    meta: {
      hideFooter: true,
      title: 'header.extension',
    },
  },
  {
    path: '/pricing/pay/callback',
    name: 'pricingPayCallback',
    component: () => import('@/views/Pricing/Pay/callback.vue'),
    meta: {
      hideFooter: true,
      title: 'header.pricing',
    },
  },
  {
    path: '/order/list',
    name: 'orderList',
    component: () => import('@/views/Pricing/Order/list.vue'),
    meta: {
      hideFooter: true,
      title: 'header.orderList',
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const navbarHeight = 68
          const element = document.querySelector(to.hash)
          if (element) {
            const elementTop =
              element.getBoundingClientRect().top + window.pageYOffset
            resolve({
              top: elementTop - navbarHeight,
              behavior: 'smooth',
            })
          } else {
            resolve({ top: 0 })
          }
        }, 800)
      })
    }
    return savedPosition || { top: 0 }
  },
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = translate(to.meta.title)
  }

  // 检查是否需要登录
  if (to.meta.requiresAuth && !localStorage.getItem('auth-token')) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export { routes, router }
